import { getCountryFlag } from "helpers/address";
import { Img } from "./Img";
import { Typography, styled, SxProps, Theme } from "@mui/material";
import type { TypographyProps } from "@mui/material";

interface CountryFlagProps extends TypographyProps {
  fd_country?: string;
  country_code?: string;
  country?: string;
  hasBorder?: boolean;
  sx?: SxProps<Theme>;
}

const CountryFlag = ({
  fd_country,
  country_code,
  country,
  hasBorder = true,
  sx,
  ...props
}: CountryFlagProps) => {
  if (!(fd_country || country)) return null;

  return (
    <StyledCompanyFlag 
      {...props} 
      className={"country_flag " + (props.className || "")}
      sx={{
        ...(hasBorder ? {
          border: "0.5px solid #EAECF0",
        } : {}),
        ...sx
      }}
    >
      {country_code && (
        <Img src={getCountryFlag(country_code).src} alt="flag" />
      )}
      {fd_country || country}
    </StyledCompanyFlag>
  );
};

const StyledCompanyFlag = styled(Typography)({
  fontSize: 12,
  fontWeight: 500,
  width: "fit-content",
  display: "flex",
  alignItems: "center",
  gap: 6,
  padding: "0 4px",
  backgroundColor: "#fff",
  borderRadius: 4,
  img: {
    width: 15,
  },
});

export default CountryFlag;
